import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-menu" }
const _hoisted_2 = { class: "profile-menu__title" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "profile-menu__list" }
const _hoisted_6 = { class: "profile-menu__list-item" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "profile-menu__list-item" }

import CaretDown from '@/assets/CaretDown.svg'
import { logout } from '@/auth/sws'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileMenu',
  props: {
    avatarUrl: null
  },
  setup(__props: any) {

const props = __props as {
  avatarUrl: string
};

const defaultAvatarUrl = 'https://static.serato.com/common/images/default-profile-picture.svg'
const profileLink = process.env.VUE_APP_CLIENT_URI_MY_ACCOUNT




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: _unref(profileLink),
        class: "profile-menu__link"
      }, [
        _createElementVNode("img", {
          src: __props.avatarUrl,
          class: _normalizeClass(['profile-menu__avatar', { 'profile-menu__avatar--default': __props.avatarUrl === defaultAvatarUrl }])
        }, null, 10, _hoisted_4)
      ], 8, _hoisted_3),
      _createVNode(_unref(CaretDown), { class: "profile-menu__icon profile-menu__icon--hoverable profile-menu__icon--lowered" })
    ]),
    _createElementVNode("ul", _hoisted_5, [
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("a", {
          class: "profile-menu__list-link",
          href: _unref(profileLink)
        }, "Manage Profile", 8, _hoisted_7)
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createElementVNode("a", {
          class: "profile-menu__list-link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(logout) && _unref(logout)(...args)))
        }, "Log out")
      ])
    ])
  ]))
}
}

})